import type { UiCmsSuperteaserBody } from '../../components.d.ts';

/**
 * Validates the different variants of the superteaser.
 * Throws an error if the selected variant is not defined in the variants object.
 */
export function validateVariant(body: UiCmsSuperteaserBody): void {
  const variants = {
    small: [
      { brandshapeOrientation: 'behind-claim', textPosition: 'left-center' },
      { brandshapeOrientation: 'hide', textPosition: 'left-center' },
    ],
    medium: [
      { brandshapeOrientation: 'behind-claim', textPosition: 'left-center' },
      { brandshapeOrientation: 'behind-text', textPosition: 'left-center' },
      { brandshapeOrientation: 'hide', textPosition: 'left-center' },

      { brandshapeOrientation: 'behind-claim', textPosition: 'left-bottom' },
      { brandshapeOrientation: 'behind-text', textPosition: 'left-bottom' },
      { brandshapeOrientation: 'hide', textPosition: 'left-bottom' },

      { brandshapeOrientation: 'behind-claim', textPosition: 'right-center' },
      { brandshapeOrientation: 'hide', textPosition: 'right-center' },

      { brandshapeOrientation: 'behind-text', textPosition: 'center-bottom' },
    ],
    large: [
      { brandshapeOrientation: 'behind-claim', textPosition: 'left-center' },
      { brandshapeOrientation: 'behind-text', textPosition: 'left-center' },
      { brandshapeOrientation: 'hide', textPosition: 'left-center' },

      { brandshapeOrientation: 'behind-claim', textPosition: 'left-bottom' },
      { brandshapeOrientation: 'behind-text', textPosition: 'left-bottom' },
      { brandshapeOrientation: 'hide', textPosition: 'left-bottom' },

      { brandshapeOrientation: 'behind-claim', textPosition: 'right-center' },
      { brandshapeOrientation: 'hide', textPosition: 'right-center' },

      { brandshapeOrientation: 'behind-text', textPosition: 'center-bottom' },
    ],
  };

  const findVariant = variants[body.variant]?.find(
    (variant) =>
      variant.brandshapeOrientation === body.brandshapeOrientation && variant.textPosition === body.textPosition
  );
  if (!findVariant) {
    const message = `Variant ${body.variant} with brandshapeOrientation ${body.brandshapeOrientation} and textPosition ${body.textPosition} is not approved by the design team and therefore should not be used.`;
    if (typeof process !== 'undefined' && process.env.STORYBOOK_ENV) {
      // eslint-disable-next-line no-alert
      alert(message);
    } else {
      // eslint-disable-next-line no-console
      console.warn(message);
    }
  }
}
